import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { FeatureFlagService } from '../services/feature-flag.service';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class LoginRedirectGuard implements CanActivate {
  constructor(
    private router: Router,
    private featureFlagService: FeatureFlagService,
    private authService: AuthService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const shouldRedirect =
      this.featureFlagService.shouldAuthenticateWithVE() &&
      this.authService.shouldUseLegacyLogin();

    if (shouldRedirect) {
      this.router.navigate(['/employee-login']);
      return false;
    }

    return true;
  }
}
